// "Rise up" (VIS-265, Film's action at a point; also a tour stop's move): the camera climbs straight up for the big
// view, still looking at the same point, so the view tilts down as it rises. At rest when it begins and ends.
// Options:
//   up      metres it climbs (default 40); negative sinks
//   travel  seconds of the flight to a tour stop (default 3.2)
import { easeInOut, posed } from './rig.js';

/** @param {import('./rig.js').View} view  @param {number} k  0..1 of the move  @returns {import('./rig.js').View} */
export function pose(view, k, o = {}) {
  const up = (Number.isFinite(o.up) ? o.up : 40) * easeInOut(Math.min(1, Math.max(0, k))), p = view.position;
  return { ...view, position: [p[0], p[1] + up, p[2]] };
}

export default function rise(o, rig) { return posed(pose, o, rig); }
